export const PLAN_TYPE = {
  MONTHLY: 'monthly',
  YEARLY: 'yearly',
}

export const SUBSCRIPTION_STATUS = {
  // Backend statuses
  ACTIVE: 'active',
  CANCELED: 'canceled',
  EXPIRED: 'expired',
  PAST_DUE: 'past_due',
  REDEMPTION: 'redemption',
  SUSPENDED: 'suspended',
  REJECTED: 'rejected',
  // Derived UI statuses
  FULLY_CANCELED: 'fully_canceled',
  PENDING_CANCEL: 'pending_cancel',
}

/**
 * Maps a backend status + canceledAt into a UI display status.
 * - canceled → FULLY_CANCELED
 * - active + canceledAt → PENDING_CANCEL (user initiated cancellation, still has access)
 * - everything else → pass-through
 */
export function resolveDisplayStatus(status, canceledAt) {
  if (status === SUBSCRIPTION_STATUS.CANCELED) return SUBSCRIPTION_STATUS.FULLY_CANCELED
  if (status === SUBSCRIPTION_STATUS.ACTIVE && canceledAt) return SUBSCRIPTION_STATUS.PENDING_CANCEL
  return status
}
